import { render, staticRenderFns } from "./PublicNumberInfo.vue?vue&type=template&id=64d8a394&"
import script from "./PublicNumberInfo.vue?vue&type=script&lang=js&"
export * from "./PublicNumberInfo.vue?vue&type=script&lang=js&"
import style0 from "./PublicNumberInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports